import React from 'react'
import PropTypes from 'prop-types'

import Field from '../Field'
import { StyledSwitch } from './Switch.style'

const Switch = ({ switchLabels, wrapperDataTestId, ...rest }) => (
  <Field
    {...rest}
    wrapperDataTestId={wrapperDataTestId}
    render={({ value, getPopupContainer, ...renderProps }) => (
      <StyledSwitch
        {...renderProps}
        switchLabels={switchLabels}
        checked={value}
      />
    )}
  />
)

Switch.defaultProps = {
  checked: false,
  switchLabels: () => '',
}

/** see `Field` for more api info */
Switch.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  hint: PropTypes.string,
  tooltip: PropTypes.string,
  forceValidation: PropTypes.bool,
  /** those will be rendered in the circle */
  switchLabels: PropTypes.func,
  wrapperDataTestId: PropTypes.string,
}

export default Switch
